import { render, staticRenderFns } from "./NuevoArchivo.vue?vue&type=template&id=393fc9be&"
import script from "./NuevoArchivo.vue?vue&type=script&lang=js&"
export * from "./NuevoArchivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports